import { useMemo } from 'react';
import { ChevronIcon } from '@ui/kit/icons';
import { sentenceInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext, TaskContext } from '../../context.js';
import { ArrowToFacitIcon } from '../icon.arrow-to-facit.js';
import { wrapper, label, container, inputWithChevronContainer, arrowToFacit } from './container.facit.style.js';
import { SentenceInput } from './input.content.js';
import { orderInputs } from './util.order-inputs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function FacitContainer(props) {
  const context = useTaskContext();
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sentenceInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: wrapper,
      "data-theme": "input",
      children: [context === "facit" && /*#__PURE__*/jsx("p", {
        className: label,
        children: "Dit svar"
      }), /*#__PURE__*/jsx("div", {
        className: container,
        children: userOrderedInputs.map((input, index) => /*#__PURE__*/jsxs("div", {
          className: inputWithChevronContainer,
          children: [/*#__PURE__*/jsx(SentenceInput, {
            node: input,
            taskEntryKey: props.taskEntryKey
          }), index !== userOrderedInputs.length - 1 && /*#__PURE__*/jsx(ChevronIcon, {
            height: 8,
            strokeWidth: 3
          })]
        }, input.id))
      })]
    }), context === "facit" && /*#__PURE__*/jsxs("div", {
      className: wrapper,
      "data-theme": "facit",
      children: [/*#__PURE__*/jsx(ArrowToFacitIcon, {
        className: arrowToFacit,
        height: 10
      }), /*#__PURE__*/jsx("p", {
        className: label,
        children: "Rigtigt svar"
      }), /*#__PURE__*/jsx("div", {
        className: container,
        children: /*#__PURE__*/jsx(TaskContext.Provider, {
          value: "readonly",
          children: props.task.content.map((input, index) => /*#__PURE__*/jsxs("div", {
            className: inputWithChevronContainer,
            children: [/*#__PURE__*/jsx(SentenceInput, {
              node: input,
              taskEntryKey: props.taskEntryKey
            }), index !== props.task.content.length - 1 && /*#__PURE__*/jsx(ChevronIcon, {
              height: 8,
              strokeWidth: 3
            })]
          }, input.id))
        })
      })]
    })]
  });
}

export { FacitContainer };
//# sourceMappingURL=container.facit.js.map
